import { KEYS } from 'game/constants/SceneConstants';
import { FONT_BASE } from 'game/constants/AppFonts';

export class DisplayDecision extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);

    this.x = 0;
    this.y = 180;

    scene.add.existing(this);

    this.sence = scene;
    this._data = scene.game._scenario.getCurrentOutcomes;
    this._type = scene.game._scenario.getCurrentScenarioType;

    this.activeOnboarding = true;
    this.displayOnboarding();
    this.activeDescision();
  }

  displayOnboarding() {
    this.onboarding = this.scene.add.container(840, this.scene.game.defaultHeight - 35 - this.y);
    this.onboarding.alpha = 0;

    const arrow = this.scene.add.sprite(0, 0, 'ui', 'pointer_up_white').setOrigin(0.5, 0);

    const text = this.scene.add
      .text(0, arrow.height + 5, 'Drag the scenario card to the option you want to choose', {
        fontFamily: FONT_BASE.CALIBRE_REGULAR,
        fontSize: '24px',
        color: '#ffffff',
        align: 'center',
      })
      .setOrigin(0.5, 0);

    this.onboarding.add([arrow, text]);

    this.add(this.onboarding);

    this.scene.tweens.add({
      targets: this.onboarding,
      y: this.scene.game.defaultHeight - 75 - this.y,
      alpha: 1,
      delay: 500,
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
    });

    if (!this.scene.game._player.onboardingSteps.decision) {
      this.scene.onboarding.showOnboarding('DESCISION');
      this.sence.game._player.updateOnboardingStep = 'decision';
    }
  }

  createOptionBox(type) {
    const box = this.scene.add.container(840, 0);

    const bg = this.scene.add.sprite(0, 0, 'ui', type).setOrigin(0.5, 0);

    box.alpha = 0;
    box.x = type == 'option_a' ? 840 - (bg.width + 20) : 840 + bg.width + 20;

    const text = this.scene.add
      .text(0, 100, this._data[type].desc, {
        fontFamily: FONT_BASE.OPEN_SANS_REGULAR,
        fontSize: '19px',
        color: '#ffffff',
        wordWrap: { width: bg.width - 40 },
        align: 'center',
      })
      .setOrigin(0.5, 0);

    box.add([bg, text]);

    this.add(box);

    return box;
  }

  createScenarioCard() {
    const card = this.scene.add.container(840, 0);

    const bg = this.scene.add.sprite(0, 0, 'ui', `scenario_${this._type}`).setOrigin(0.5, 0);

    card.alpha = 0;

    const text = this.scene.add
      .text(0, this._type == 'dialogue' ? 25 : 100, this._data.card.desc, {
        fontFamily: FONT_BASE.OPEN_SANS_REGULAR,
        fontSize: '19px',
        color: '#ffffff',
        wordWrap: { width: bg.width - 40 },
        align: 'center',
      })
      .setOrigin(0.5, 0);

    card.add([bg, text]);

    card.setSize(bg.width, bg.height * 2);

    this.add(card);

    return card;
  }

  activeDescision(card) {
    // create both options
    this.optDisplayLeft = this.createOptionBox('option_a');
    this.optDisplayRight = this.createOptionBox('option_b');
    this.activeCard = this.createScenarioCard();

    this.scene.tweens.add({
      targets: this.activeCard,
      y: 0,
      alpha: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
    });

    this.scene.tweens.add({
      targets: [this.optDisplayRight, this.optDisplayLeft],
      alpha: 1,
      delay: 400,
      duration: 700,
      ease: Phaser.Math.Easing.Back.Out,
      onComplete: () => {
        this.activeCard.setInteractive({ draggable: true, useHandCursor: true });
      },
    });

    this.activeCard.on('dragstart', () => {
      if (this.activeOnboarding) {
        this.activeOnboarding = false;
        this.scene.tweens.add({
          targets: this.onboarding,
          alpha: 0,
          delay: 300,
          duration: 500,
          ease: Phaser.Math.Easing.Back.Out,
        });
      }
    });

    this.activeCard.on('drag', (pointer, dragX, dragY, dropped) => {
      this.activeCard.x = Math.max(540, Math.min(1140, dragX));
      const dx = Math.abs(840 - this.activeCard.x);
      const dir = this.activeCard.x > 840 ? 1 : -1;
      this.activeCard.angle = 15 * Math.min(1, dx / 200) * dir;
      if (dx > 150) {
        this.optDisplayRight.list[0].setTexture(
          'ui',
          this.activeCard.x > 840 ? 'option_b_over' : 'option_b'
        );
        this.optDisplayRight.list[1].setColor(this.activeCard.x > 840 ? '#ffd64d' : '#ffffff');
        this.optDisplayLeft.list[0].setTexture(
          'ui',
          this.activeCard.x < 840 ? 'option_a_over' : 'option_a'
        );
        this.optDisplayLeft.list[1].setColor(this.activeCard.x < 840 ? '#ffd64d' : '#ffffff');
      } else {
        this.optDisplayRight.list[0].setTexture('ui', 'option_b');
        this.optDisplayRight.list[1].setColor('#ffffff');

        this.optDisplayLeft.list[0].setTexture('ui', 'option_a');
        this.optDisplayLeft.list[1].setColor('#ffffff');
      }
    });
    this.activeCard.on('dragend', (pointer, dragX, dragY) => {
      const dx = Math.abs(840 - this.activeCard.x);
      const dir = this.activeCard.x > 840 ? 1 : -1;

      this.activeCard.x = dir > 0 ? this.optDisplayRight.x : this.optDisplayLeft.x;
      this.activeCard.angle = 0;
      if (dx > 150) {
        this.activeCard.removeInteractive();

        this.sence.game.soundController.playSFX('sfx', 'chn_card_place');

        setTimeout(() => {
          const playersChoice = this.activeCard.x < 840 ? 'option_a' : 'option_b';
          this.setPlayersChoice(playersChoice);
        }, 500);
      } else {
        this.activeCard.x = 840;
        this.activeCard.angle = 0;
      }
    });
  }

  setPlayersChoice(choice) {
    this.scene.game._scenario.setPlayersChoice(choice);
    this.scene.game._scores.setScores =
      this.scene.game._scenario.getCurrentScenarioPlayersChoiceData.scores;

    this.scene.game.sceneController.switchScene(KEYS.ScenarioOutcome);
  }

  shutdown() {
    this.destroy();
  }
}
